module.exports = __webpack_public_path__ + "Banner_ExerciseExploration-e6534d65fd5d553682f9d7bce88eadd2.svg";